import React from "react";

const AccountStatusBadge: React.FC<{
  variant:
    | "current"
    | "enrolled"
    | "delegate"
    | "shared"
    | "autopay"
    | "expired"
    | "pending"
    | "inactive";
  className?: string;
}> = ({ variant, className = "" }) => {
  const labels = {
    current: "This Account",
    enrolled: "AutoPay Enabled",
    delegate: "Delegate payment method",
    shared: "Shared account",
    autopay: "AutoPay",
    expired: "Expired",
    pending: "Pending verification",
    inactive: "Inactive",
  };
  const styleVariant =
    variant === "enrolled" || variant === "autopay"
      ? "current"
      : variant === "shared" || variant === "pending"
        ? "shared"
        : variant === "expired"
          ? "expired"
          : variant === "inactive"
            ? "delegate"
            : variant;

  return (
    <span
      className={`badge autopay-account-badge autopay-account-badge-${styleVariant} ${className}`.trim()}
    >
      {labels[variant]}
    </span>
  );
};

export default AccountStatusBadge;
